module.exports = __webpack_public_path__ + "images/CSFB_Legend_dee02836c0b1d0e487dbf8b63e7bb244.png";